// Re-export auth hooks from core for convenience
export { useLogin, useLogout, useMe } from '../core/hooks/use-auth';
// Re-export the auth store
export { useAuthStore } from '../stores/auth-store';
export type { User } from '../stores/auth-store';

// WAYP-INVITE: memberships hook for the org switcher.
import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';
import { useAuthStore as _useAuthStore } from '../stores/auth-store';

export interface OrgMembership {
  organizationId: string;
  organizationName: string;
  organizationSlug: string;
  role: string;
}

export function useMyMemberships() {
  const isAuthenticated = _useAuthStore((s) => s.isAuthenticated);
  return useQuery({
    queryKey: ['auth', 'me', 'memberships'] as const,
    queryFn: async (): Promise<OrgMembership[]> => {
      const res = await api.get<{ data: { memberships: OrgMembership[] } }>('/auth/me');
      return res.data.data.memberships ?? [];
    },
    enabled: isAuthenticated,
    staleTime: 60 * 1000,
  });
}
